const EMPLEADOS = [
  { id: 1, nombre: 'Ana Martínez', sucursalId: 1, sucursalNombre: 'Casa Central' },
  { id: 2, nombre: 'Julián Ríos', sucursalId: 2, sucursalNombre: 'Sucursal Norte' },
  { id: 3, nombre: 'Carla Gutiérrez', sucursalId: 1, sucursalNombre: 'Casa Central' },
  { id: 4, nombre: 'Luis Fernández', sucursalId: 3, sucursalNombre: 'Operaciones Oeste' },
];

const METODOS = ['Manual', 'GPS', 'QR'];
const ESTADOS_ASISTENCIAS = ['EnCurso', 'Completa', 'Ausente', 'Tarde'];
const ESTADOS_ASIGNACION = ['Activa', 'Pausada', 'Finalizada'];
const ESTADOS_VACACIONES = ['Solicitada', 'Aprobada', 'Rechazada', 'Goce'];

function randomItem(array, index = 0) {
  return array[index % array.length];
}

export function createAsistenciaSeeds() {
  const seeds = [];
  const now = new Date();
  for (let index = 0; index < 18; index += 1) {
    const empleado = EMPLEADOS[index % EMPLEADOS.length];
    const fecha = new Date(now.getFullYear(), now.getMonth(), now.getDate() - index);
    const estado = randomItem(ESTADOS_ASISTENCIAS, index);
    const checkInHour = 8 + (index % 3);
    const checkOutHour = estado === 'Ausente' ? null : checkInHour + 8;
    seeds.push({
      id: index + 1,
      empleadoId: empleado.id,
      empleadoNombre: empleado.nombre,
      sucursalId: empleado.sucursalId,
      sucursalNombre: empleado.sucursalNombre,
      fecha: fecha.toISOString().slice(0, 10),
      checkIn: checkInHour != null ? `${String(checkInHour).padStart(2, '0')}:05` : null,
      checkOut: checkOutHour != null ? `${String(checkOutHour).padStart(2, '0')}:10` : null,
      metodo: randomItem(METODOS, index),
      lat: -34.60 + index * 0.01,
      lng: -58.38 + index * 0.01,
      estado,
      notas: estado === 'Tarde' ? 'Ingreso fuera de horario' : '',
    });
  }
  return seeds;
}

export function createTurnoSeeds() {
  return [
    {
      id: 1,
      nombre: 'Turno Mañana',
      descripcion: 'Ingreso 8hs, descanso 30 minutos.',
      horaEntrada: '08:00',
      horaSalida: '16:00',
      descansoMinutos: 30,
      aplicaFinesDeSemana: false,
      sucursalId: 1,
      sucursalNombre: 'Casa Central',
      activo: true,
      creadoEn: new Date().toISOString(),
    },
    {
      id: 2,
      nombre: 'Turno Tarde',
      descripcion: 'Ingreso 12hs, salida 20hs.',
      horaEntrada: '12:00',
      horaSalida: '20:00',
      descansoMinutos: 45,
      aplicaFinesDeSemana: true,
      sucursalId: 2,
      sucursalNombre: 'Sucursal Norte',
      activo: true,
      creadoEn: new Date().toISOString(),
    },
    {
      id: 3,
      nombre: 'Turno Noche',
      descripcion: 'Cobertura nocturna logística.',
      horaEntrada: '22:00',
      horaSalida: '06:00',
      descansoMinutos: 60,
      aplicaFinesDeSemana: true,
      sucursalId: 3,
      sucursalNombre: 'Operaciones Oeste',
      activo: false,
      creadoEn: new Date().toISOString(),
    },
  ];
}

export function createAsignacionesTurnoSeeds(turnos = []) {
  return turnos.slice(0, 2).map((turno, index) => {
    const empleado = EMPLEADOS[(index + 1) % EMPLEADOS.length];
    return {
      id: index + 1,
      turnoId: turno.id,
      turnoNombre: turno.nombre,
      empleadoId: empleado.id,
      empleadoNombre: empleado.nombre,
      desde: `2024-0${index + 1}-01`,
      hasta: index % 2 === 0 ? `2024-0${index + 2}-15` : null,
      estado: randomItem(ESTADOS_ASIGNACION, index),
      sucursalId: empleado.sucursalId,
      sucursalNombre: empleado.sucursalNombre,
    };
  });
}

export function createVacacionesSeeds() {
  const seeds = [];
  for (let index = 0; index < 12; index += 1) {
    const empleado = EMPLEADOS[index % EMPLEADOS.length];
    const desde = new Date(2024, (index % 6) + 1, 3);
    const hasta = new Date(desde);
    hasta.setDate(hasta.getDate() + 6);
    const diasTomados = calculateDias(hasta, desde);
    const estado = randomItem(ESTADOS_VACACIONES, index);
    seeds.push({
      id: index + 1,
      empleadoId: empleado.id,
      empleadoNombre: empleado.nombre,
      sucursalId: empleado.sucursalId,
      sucursalNombre: empleado.sucursalNombre,
      periodo: `202${index % 3 + 2}`,
      desde: desde.toISOString().slice(0, 10),
      hasta: hasta.toISOString().slice(0, 10),
      diasTomados,
      diasRestantes: Math.max(0, 15 - diasTomados - index % 3),
      estado,
      aprobadorId: estado === 'Aprobada' ? 100 + index : null,
      aprobadorNombre: estado === 'Aprobada' ? 'RRHH Manager' : null,
      notas: estado === 'Rechazada' ? 'Reprogramar para después del cierre fiscal.' : '',
    });
  }
  return seeds;
}

function calculateDias(hasta, desde) {
  return Math.max(1, Math.round((hasta - desde) / (1000 * 60 * 60 * 24)) + 1);
}

export { EMPLEADOS };
